import { render, staticRenderFns } from "./HeaderHome.vue?vue&type=template&id=43b696be&%3Akey=notificationsKey"
import script from "./HeaderHome.vue?vue&type=script&lang=ts"
export * from "./HeaderHome.vue?vue&type=script&lang=ts"
import style0 from "./HeaderHome.vue?vue&type=style&index=0&id=43b696be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports